import * as React from 'react';
import {cssTranslate, getPosition, setPosition} from './utils';
import {AnimationHandler, IAnimationHandlerResponse, SwipeAnimationHandler, StopSwipingHandler} from './ICarousel';

export const slideAnimationHandler: AnimationHandler = (props, state, newPosition): IAnimationHandlerResponse => {
    const returnStyles: IAnimationHandlerResponse = {};
    const {selectedItem} = state;
    const perviousItem = selectedItem;
    const nextItem =( typeof (newPosition) !== 'undefined') ? newPosition : perviousItem;

    const targetItem = nextItem / props.slideToChange;

    const currentPosition = getPosition(targetItem, props);

    const transformProp = cssTranslate(currentPosition, '%', props.axis);

    const transitionTime = props.transitionTime + 'ms';

    returnStyles.itemListStyle = {
        transform: transformProp,
        transitionDuration: transitionTime,
    };
    return returnStyles;

};

export const slideSwipeAnimationHandler: SwipeAnimationHandler = (
    delta,
    props,
    state,
    setState,
): IAnimationHandlerResponse => {
    const returnStyles: IAnimationHandlerResponse = {};
    const isHorizontal = props.axis === 'horizontal';
    const childrenLength = React.Children.count(props.children);

    const initialBoundry = 0;

    const currentPosition = getPosition(state.selectedItem, props);
    const finalBoundry = props.infiniteLoop ? getPosition(childrenLength -1, props) -100 : getPosition(childrenLength -1, props);

    const axisDelta = isHorizontal ? delta.x : delta.y;
    let handleDelta = axisDelta;
    let position!: number;

    if(currentPosition === initialBoundry && axisDelta > 0) {
        handleDelta = 0;
    }

    if(currentPosition === finalBoundry && axisDelta < 0) {
        handleDelta = 0;
    }

    if(state.itemSize === 1) {

        position =currentPosition;

    }
    else{
        position = currentPosition + 100 / (state.itemSize / handleDelta);

    }

    const hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

    if(!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
        if(!state.swipeMovementStarted) {
            setState({ type: 'swipeMovementStarted', swipeMovementStarted: {swipeMovementStarted: true}});
        }
        returnStyles.itemListStyle = {...setPosition(position, props.axis)};
    }

    if(hasMoved && !state.cancelClick) {

        setState({type: 'cancelClick', cancelClick: {cancelClick: true}});
    }
    return returnStyles;

};

export const slideStopSwipingHandler: StopSwipingHandler = (props, state): IAnimationHandlerResponse => {
    const currentPosition = getPosition(state.selectedItem, props);
    const itemListStyle = setPosition(currentPosition, props.axis);
    const styles = {
        transform: itemListStyle.transform,
        transitionDuration: props.transitionTime + 'ms'
    };

    return { itemListStyle: styles };
};

export const fadeAnimationHandler: AnimationHandler = (props, state): IAnimationHandlerResponse => {
    const transitionTime = props.transitionTime + 'ms';
    const transitionTimingFunction = 'ease-in-out';
    let slideStyle: React.CSSProperties = {
        display: 'block',
        zIndex: -1,
        minHeight: '100%',
        opacity: 0,
        top: 0,
        right: 0,
        bottom: 0,
        transitionTimingFunction: transitionTimingFunction,
        transitionDuration: props.transitionTime + 'ms',
    };

    if(!state.swiping) {
        slideStyle = {
            ...slideStyle,
            transitionDuration: transitionTime
        };
    }

    return {
        slideStyle,
        prevStyle: { ...slideStyle},
        selectedStyle: {...slideStyle, opacity: 1, position: 'absolute'},
    };
};
